import React from 'react';

// Main App component to render the accounting report
const ReportTemplate = () => {
    // Sample data for a Trial Balance report
    const reportData = [
        { code: '101', name: 'Cash', debit: 25000, credit: 0 },
        { code: '102', name: 'Accounts Receivable', debit: 15000, credit: 0 },
        { code: '105', name: 'Office Supplies', debit: 2000, credit: 0 },
        { code: '201', name: 'Accounts Payable', debit: 0, credit: 7000 },
        { code: '205', name: 'Notes Payable', debit: 0, credit: 12000 },
        { code: '301', name: 'Common Stock', debit: 0, credit: 20000 },
        { code: '401', name: 'Service Revenue', debit: 0, credit: 11000 },
        { code: '501', name: 'Rent Expense', debit: 4000, credit: 0 },
        { code: '502', name: 'Salaries Expense', debit: 1000, credit: 0 },
        { code: '503', name: 'Utilities Expense', debit: 1000, credit: 0 },
    ];

    // Calculate the total debits and credits
    const totalDebits = reportData.reduce((sum, item) => sum + item.debit, 0);
    const totalCredits = reportData.reduce((sum, item) => sum + item.credit, 0);

    // Get current date and time for the report header
    const currentDate = new Date().toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });
    const currentTime = new Date().toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
    });

    return (
        <div className="font-sans antialiased text-gray-800 bg-gray-50 p-4 md:p-8 min-h-screen flex items-center justify-center">
            <div className="w-full max-w-4xl bg-white shadow-xl rounded-2xl overflow-hidden border border-gray-200">

                {/* Report Header */}
                <div className="p-6 md:p-8 bg-gray-100 border-b border-gray-200">
                    <h1 className="text-3xl font-bold text-gray-900 text-center mb-1">
                        Gemini Ventures Inc.
                    </h1>
                    <h2 className="text-xl font-semibold text-gray-700 text-center mb-1">
                        Trial Balance
                    </h2>
                    <p className="text-md text-gray-600 text-center">
                        For the month ended {currentDate}
                    </p>
                    <div className="text-sm text-gray-500 text-center mt-2">
                        <span>Report Generated: {currentDate} at {currentTime}</span>
                    </div>
                </div>

                {/* Accounting Table */}
                <div className="p-6 md:p-8 overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-300 rounded-lg">
                        {/* Table Header */}
                        <thead className="bg-gray-100">
                            <tr>
                                <th
                                    scope="col"
                                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider rounded-tl-lg"
                                >
                                    Account Code
                                </th>
                                <th
                                    scope="col"
                                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    Account Name
                                </th>
                                <th
                                    scope="col"
                                    className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    Debit
                                </th>
                                <th
                                    scope="col"
                                    className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider rounded-tr-lg"
                                >
                                    Credit
                                </th>
                            </tr>
                        </thead>

                        {/* Table Body */}
                        <tbody className="bg-white divide-y divide-gray-200">
                            {reportData.map((account) => (
                                <tr key={account.code} className="hover:bg-gray-50">
                                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                                        {account.code}
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                                        {account.name}
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-right text-gray-900">
                                        {account.debit > 0 && `$${account.debit.toLocaleString()}`}
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-right text-gray-900">
                                        {account.credit > 0 && `$${account.credit.toLocaleString()}`}
                                    </td>
                                </tr>
                            ))}
                        </tbody>

                        {/* Table Totals Row */}
                        <tfoot>
                            <tr className="bg-gray-200 font-semibold border-t-2 border-gray-400">
                                <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-800 rounded-bl-lg">
                                    Total:
                                </td>
                                <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-800"></td>
                                <td className="px-6 py-3 whitespace-nowrap text-sm text-right text-gray-900">
                                    ${totalDebits.toLocaleString()}
                                </td>
                                <td className="px-6 py-3 whitespace-nowrap text-sm text-right text-gray-900 rounded-br-lg">
                                    ${totalCredits.toLocaleString()}
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default ReportTemplate;


